module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma/6-72da593b731f0f1e606530b3dcb1cb83.png";